








































































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import OrderRefundApi from '@/api/order/refund/index'

@Component({
  components: {
    CustomForm
  }
})
export default class RefundReasonSetting extends AbpBase {
  filters = [
    {
      label: '原因类型：',
      type: 'input',
      key: 'name',
      rule: { required: true, message: '请输入原因类型', trigger: 'blur' }
    },
    {
      label: '排序：',
      type: 'input',
      props: { type: 'number' },
      defaultValue: 0,
      key: 'displayOrder'
    },
    {
      label: '是否启用：',
      type: 'switch',
      key: 'published'
    }
  ]
  columns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center'
    },
    {
      title: '原因类型',
      key: 'name',
      align: 'center'
    },
    {
      title: '排序',
      key: 'displayOrder',
      align: 'center'
    },
    {
      title: '是否启用',
      slot: 'published',
      align: 'center'
    },
    {
      title: '操作',
      slot: 'action',
      width: 150,
      align: 'center'
    }
  ]
  loading: boolean = false
  tableData: any[] = []
  page = {
    totalCount: 100,
    currentPage: 1,
    maxResultCount: 10
  }
  editModal = false
  modal_loading = false
  editId = null
  isCheckAll = false

  created() {
    this.getRefundReasonList()
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  /**
   * 新增/更新退款原因
   */
  onSubmit(form, valid) {
    if (valid) {
      let name = form['name']
      let displayOrder = form['displayOrder']
      let published = form['published']
      OrderRefundApi.updateRefundReason(
        name,
        displayOrder,
        published,
        this.editId
      ).then(res => {
        this.modalCancel()
        this.getRefundReasonList()
      })
    }
  }

  modalCancel() {
    let form: any = this.$refs.lineForm
    form.reset()
    this.editModal = false
    this.editId = null
  }

  /**
   * 编辑
   */
  editRow(row) {
    this.editId = row.id
    let obj = {
      name: row.name,
      displayOrder: row.displayOrder,
      published: row.published
    }
    let form: any = this.$refs.lineForm
    form.setForm(obj)
    this.editModal = true
  }

  changePage(e) {
    this.page.currentPage = e
    this.getRefundReasonList()
  }
  pageSizeChange(e, t) {
    this.page.maxResultCount = e
    this.page.currentPage = 1
    this.getRefundReasonList()
  }
  switchChange(status, row) {
    OrderRefundApi.updateRefundReason(
      row.name,
      row.displayOrder,
      status,
      row.id
    ).then(res => {
      this.getRefundReasonList()
    })
  }

  /**
   * 获取退款原因列表
   */
  getRefundReasonList() {
    this.loading = true
    let { page } = this
    OrderRefundApi.getRefundReasonList(page.maxResultCount, page.currentPage)
      .then(res => {
        this.loading = false
        this.page.totalCount = res.data.totalCount
        this.tableData = res.data.items
      })
      .catch(err => {
        this.loading = false
      })
  }

  /**
   * 批量删除退款原因
   */
  deleteRefundReason(ids: number[]) {
    this.$Modal.confirm({
      title: '提示',
      content: `确认删除已选退款原因？`,
      onOk: () => {
        this.loading = true
        OrderRefundApi.deleteRefundReason(ids)
          .then(res => {
            this.loading = false
            this.$Notice.success({ desc: '删除成功' })
            this.getRefundReasonList()
          })
          .catch(err => {
            this.loading = false
          })
      }
    })
  }

  deleteSelectd() {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      let ids = selection.map(item => {
        return item.id
      })
      this.deleteRefundReason(ids)
    } else {
      this.$Notice.warning({
        title: '请先选择要删除的数据'
      })
    }
  }

  handleTableAllCancel() {
    this.isCheckAll = false
  }

  handleTableAll() {
    this.isCheckAll = true
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }
  handleSelectAll() {
    if (!this.tableData.length) return
    ;(this.$refs.selection as any).selectAll(!this.isCheckAll)
  }
}
